module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  var util = require('util/Util.js').default; 
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Screen</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row\" style=\"display: ")
    ; __append(escapeFn( displayCenterSettings ))
    ; __append("\">\r\n        <div class=\"col-md-5 form-group-flex nopadding-r\" style=\"min-width: 110px\">\r\n            <input type=\"checkbox\" id='centerVertical' name=\"centerVertical\" ")
    ; __append(escapeFn(util.isTrue(centerVertical)? 'checked' :''))
    ; __append(" class=\"form-radio-group\"/>\r\n            <label class=\"form-group-label\">Center Vertically</label>\r\n        </div>\r\n        <div class=\"col-md-5 nopadding form-group-flex\" style=\"min-width: 110px; float: right;\">\r\n            <input type=\"checkbox\" id=\"'centerHorizontal\" name=\"centerHorizontal\" ")
    ; __append(escapeFn(util.isTrue(centerHorizontal)? 'checked' :''))
    ; __append(" class=\"form-radio-group\"/>\r\n            <label class=\"form-group-label\">Center Horizontally</label>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 subsection\">\r\n            <label class=\"prop-sublabel label-35\">Color</label>\r\n            <div id=\"outsideColorPikerContainer\"></div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row\" style=\"display: ")
    ; __append(escapeFn( displayShadowSettings ))
    ; __append("\">\r\n        <div class=\"col-md-12 form-group-flex\">\r\n            <input type=\"checkbox\" id=\"shadow\" name=\"shadow\" ")
    ; __append(escapeFn(util.isTrue(shadow)? 'checked' :'' ))
    ; __append(" class=\"form-radio-group\"/>\r\n            <label class=\"form-group-label\">Drop-shadow</label>\r\n        </div>\r\n    </div>\r\n\r\n</div>")
  }
  return __output;

}